<h2 mat-dialog-title>
  <svg class="icon-24"><use href="assets/images/ok-icons-sprite.svg#edit-s"></use></svg>
  Ændr status
</h2>
<button class="btn-close btn-icon" mat-dialog-close>
  <mat-icon class="material-icons">close</mat-icon>
</button>
<form [formGroup]="form" (ngSubmit)="submitForm()">
  <mat-dialog-content>
    @if (showForm) {
      <div class="form-row">
        <mat-form-field>
          <mat-label>Vælg status</mat-label>
          <mat-select formControlName="status" [(value)]="currentStatus" okCustomDropDownArrowDirective>
            @if (data.incident.status === incidentStatus.Reported) {
              <mat-option [value]="incidentStatus.Reported"> Indmeldt </mat-option>
            }
            <mat-option [value]="incidentStatus.Active"> Aktiv </mat-option>
            @if (data.incident.status !== incidentStatus.Closed) {
              <mat-option [value]="incidentStatus.Closed"> Løst </mat-option>
            }
          </mat-select>
          <mat-icon matSuffix></mat-icon>
        </mat-form-field>
      </div>
      <div class="form-row">
        <mat-form-field class="mdc-textarea-fix">
          <mat-label>Kommentar</mat-label>
          <textarea formControlName="comment" matInput rows="5"></textarea>
        </mat-form-field>
        @if (comment.hasError('whitespace')) {
          <mat-error>
            <div>Beskrivelse må ikke kun indeholde mellemrum</div>
          </mat-error>
        }
      </div>
    }
    @if (!showForm && incidentEvent) {
      <p class="text-danger">
        Denne fejl har allerede status <em>{{ incidentEvent.status | translateIncidentStatusEnum }}</em> og kan således ikke sættes til
        <em>{{ incidentEvent.status | translateIncidentStatusEnum }}</em> igen.
      </p>
      <table class="table">
        <tbody>
          <tr valign="top">
            <td>
              <strong>Status:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ incidentEvent.status | translateIncidentStatusEnum }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Sidst ændret:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ incidentEvent.created | date: 'short' }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Sidst ændret af:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ incidentEvent.createdBy }}
              </div>
            </td>
          </tr>
          <tr valign="top">
            <td>
              <strong>Kommentar:</strong>
            </td>
            <td class="align-right">
              <div>
                {{ incidentEvent.comment }}
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    }
  </mat-dialog-content>
  <mat-dialog-actions>
    <div class="unit-identifier">
      <span>ID:</span>
      {{ data.incident.number | formatIncident }}
    </div>

    @if (showForm) {
      <button mat-dialog-close type="button" mat-button>Annuller</button>
    }

    @if (showForm) {
      <button type="submit" mat-raised-button color="primary" [disabled]="form.invalid || data.incident.status === status.value">
        Ændr status
      </button>
    }

    @if (!showForm && incidentEvent) {
      <button mat-dialog-close type="button" mat-raised-button color="primary">Luk</button>
    }
  </mat-dialog-actions>
</form>
